import { LitElement, html } from "lit-element";
import { icon_colorLens } from "../Resources/drawing-icons";
export class DrawColorsModule extends LitElement {
	get MainTb() {
		return {
			value: "color",
			icon: icon_colorLens,
			text: "color"
		};
	}

	Activate() {
		return this;
	}

	render() {
		return html`
            <style>
                :host {
                    height: 100%;
                    width: 70px;
                    position: absolute;
                    right: 0px;
                }
              
                .colors {
                    width: 100%;
                    height: calc(100vh - 60px);
                    display: flex;
                    flex-direction: column;
                }
            
                label {
                    height: 100%;
                    display: flex;  
                    cursor: pointer;
                }

                label[selected] {
                    border-radius: 0px;
                    margin: 4px;
                    box-shadow: 0px 0px 2px 3px white;
                }

                label[selected]:after {
                    content: 'selected';
                    font-size: 11px;
                    background: black;
                    padding: 0 2px;
                    margin: auto 5px;

                }
            </style>
           
            <div class="colors">
                ${this._items.map((i, index) => this._renderItem(i, index))}
            </div>`;
	}

	_renderItem(i, index) {
		const cls = "color_item_" + index;
		const stl = html`
            <style>
                .${cls} {
                    background-color: ${i};
                }
            </style>`;
		return html`
             ${stl}
            <label ?selected="${this.activeColor ===
            i}" class="${cls}" @click="${e =>
	this._handleChangeEvent(e, i)}">&nbsp;</label>`;
	}

	_handleChangeEvent(e, i) {
		this.activeColor = i;
		let target = e.currentTarget;
		for (let element of target.parentElement.children)
			element.removeAttribute("selected");

		target.setAttribute("selected", "selected");

		this.__colorChageCallbacks.forEach(c => c());
		this.dispatchEvent(
			new CustomEvent("activate-previous-module", {
				detail: {},
				composed: true
			})
		)
	}

	static get properties() {
		return { _items: Array };
	}

	onColorChange(callback) {
		if (typeof callback === "function") this.__colorChageCallbacks.push(callback);
	}

	constructor(onColorChange) {
		super();
		this.__colorChageCallbacks = [];

		this.onColorChange(onColorChange);

		//took from https://sashat.me/2017/01/11/list-of-20-simple-distinct-colors/
		this._items = [
			"#ff0000",
			"#00ff00",
			"#ffff00",
			"#0000ff",
			"#f58231",
			"#911eb4",
			"#00fefe",
			"#ff00ff",
			"#bfef45",
			"#fabebe",
			"#9A6324",
			"#aaffc3",
			"#808000",
			"#a9a9a9",
			"#ffffff",
			"#202020"
		];
		this.activeColor = "#000000";
	}
}

window.customElements.define("inspx-draw-colors", DrawColorsModule);
